import { Api, type ApiConfig, type RequestParams } from './api';
import {
  type CustomRequestParams,
  getProxyClusterId,
  MultiClusterHttpClient,
} from './multi-cluster-http-client';

// global k10 baseURL without trailing slash
const k10BaseURL = window.location.pathname.replace(/\/$/, '');

const commonConfig: ApiConfig = {
  baseURL: k10BaseURL,
};

export const dashboardBffClient = new Api(
  new MultiClusterHttpClient({
    ...commonConfig,
    serviceBaseURL: '/dashboardbff-svc/v0',
  }),
);

export const authClient = new Api(
  new MultiClusterHttpClient({
    ...commonConfig,
    serviceBaseURL: '/auth-svc/v0',
  }),
);

export const prometheusClient = new Api(
  new MultiClusterHttpClient({
    ...commonConfig,
    serviceBaseURL: '/prometheus/api/v1',
  }),
);

export type MulticlusterRequestParams = RequestParams<CustomRequestParams>;
export { getProxyClusterId };
